<div class="breadcrumb_main_box">
  <ol class="breadcrumb breadcrumb_ol_new">
    <li class="breadcrumb-item" *ngFor="let item of breadcrumbsArray; let i = index">
      <a (click)="goToPageLink(item.page_ref)">
        {{ item.page_title }}
      </a>
    </li>
  </ol>
</div>




<div>
  <mat-toolbar class="top_headerbar">
    <h6 class="show-title">Plant Dashboard</h6>

    <div class="col-md-12 tab_buttons">
      <div class="tab_flex">
        <div class="left">
          <button style="margin-right: 8px;margin-bottom: 5px" mat-button class="btn" 
            (click)="selectItem('1day')" [style.background-color]="tabColor === '1day'?btnColour: btnColor2">
            1 day
          </button>
          <button style="margin-right: 8px;margin-bottom: 5px" mat-button class="btn"
            (click)="selectItem('1week')">
            1 week
          </button>
          <button style="margin-right: 8px;margin-bottom: 5px" mat-button class="btn"
            (click)="selectItem('1month')">
            1 month
          </button>
          <button style="margin-right: 8px;margin-bottom: 5px" mat-button class="btn" 
            (click)="selectItem('3month')" >
            3 months
          </button>
        </div>
    

      </div>
    </div>
    
 
  
  </mat-toolbar>



  <p *ngIf="showEmptyError !== ''" style="font-size: 16px;
  color: #838383;
  text-align: center;
  padding: 30px;">{{showEmptyError}}</p>

  <mat-card *ngIf="showList">
    <div class="table-responsive-lg">
      <table class="table table-bordered" style="font-size: 14px;
      text-transform: initial;">
      <thead>
        <tr>
          <th scope="col">site</th>
          <th scope="col">application</th>
          <th scope="col">asset</th>
          <th scope="col">make</th>
          <th scope="col">status</th>
          <th scope="col">issue</th>
          <th scope="col">% Full Load Range</th>
          <th scope="col">No. of stops</th>
          <th scope="col">Run-time (Hours)</th>
          <th scope="col">Last service date</th>
          <th scope="col">Service performed</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of dataSource">
          <td>{{data.site}}</td>
          <td>{{data.application}}</td>
          <td>{{data.asset}}</td>
          <td>{{data.make}}</td>
          <td *ngIf="data.status ==='HEALTHY'" style="background: #83ab52;"></td>
          <td *ngIf="data.status ==='ERROR'" style="background: #c0403f;"></td>
          <td *ngIf="data.status ==='UNHEALTHY'" style="background: #efd613;"></td>
          <td>{{data.issue}}</td>
          <td>{{data.range}}</td>
          <td>{{data.stops}}</td>
          <td>{{data.run_time}}</td>
          <td>{{data.last_service}}</td>
          <td>{{data.service_performed}}</td>
        </tr>
      </tbody>
    </table>
  </div>
  </mat-card>
  


</div>